import { bindable } from 'aurelia';
import { SchedulerSetting } from './scheduler-setting';

export class SchedulerSettingEditor {
    @bindable public setting: SchedulerSetting = null;

    public readonly extraRoundOptions: number[] = [1, 2, 3, 4, 5];

    public adjacentHelpVisible: boolean = false;
    public intervalHelpVisible: boolean = false;

    public showAdjacentHelp(): void {
        this.adjacentHelpVisible = true;
    }
    public hideAdjacentHelp(): void {
        this.adjacentHelpVisible = false;
    }

    public showIntervalHelp(): void {
        this.intervalHelpVisible = true;
    }
    public hideIntervalHelp(): void {
        this.intervalHelpVisible = false;
    }
}
